const STORAGE_KEY = 'worthouse_has_cart_items'

const isCartOrCheckout = () => {
  const body = document.body
  return body.classList.contains('woocommerce-cart') || body.classList.contains('woocommerce-checkout')
}

const getCartUrl = () => {
  if (window.worthouseTheme && window.worthouseTheme.cartUrl) return window.worthouseTheme.cartUrl
  if (window.wc_add_to_cart_params && window.wc_add_to_cart_params.cart_url) return window.wc_add_to_cart_params.cart_url
  return '/cart/'
}

const getSeeOrderLabel = () => {
  if (window.worthouseTheme && window.worthouseTheme.seeOrderLabel) return window.worthouseTheme.seeOrderLabel
  return 'See order'
}

const parseCountFromHtml = (html) => {
  if (!html) return 0
  const wrapper = document.createElement('div')
  wrapper.innerHTML = html
  const node = wrapper.querySelector('.site-header__cart-count')
  if (!node) return 0
  const raw = node.getAttribute('data-count') || node.textContent || '0'
  const value = parseInt(raw, 10)
  return Number.isFinite(value) ? value : 0
}

const normalizeResponse = (response) => {
  if (typeof response !== 'string') return response

  try {
    return JSON.parse(response || '{}')
  } catch (error) {
    return {}
  }
}

const applyHeaderCount = (count) => {
  document.querySelectorAll('.site-header__cart-count').forEach((node) => {
    node.textContent = String(count)
    node.setAttribute('data-count', String(count))

    if (count > 0) {
      node.removeAttribute('hidden')
    } else {
      node.setAttribute('hidden', '')
    }
  })
}

const mountSeeOrderCta = () => {
  let cta = document.querySelector('[data-see-order-cta]')

  if (cta) return cta

  cta = document.createElement('a')
  cta.className = 'see-order-cta'
  cta.href = getCartUrl()
  cta.textContent = getSeeOrderLabel()
  cta.setAttribute('data-see-order-cta', '')
  document.body.appendChild(cta)
  return cta
}

const setSeeOrderVisible = (visible) => {
  if (isCartOrCheckout()) return
  const cta = mountSeeOrderCta()
  cta.classList.toggle('is-visible', visible)
}

const setHasItemsState = (hasItems) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, hasItems ? '1' : '0')
  } catch (error) {
    // Ignore.
  }

  setSeeOrderVisible(hasItems)
}

const mountNotice = () => {
  let notice = document.querySelector('[data-cart-feedback]')

  if (notice) return notice

  notice = document.createElement('div')
  notice.className = 'cart-feedback'
  notice.textContent = 'Added to cart'
  notice.setAttribute('data-cart-feedback', '')
  document.body.appendChild(notice)
  return notice
}

const showNotice = () => {
  const notice = mountNotice()
  notice.classList.add('is-visible')
  window.setTimeout(() => notice.classList.remove('is-visible'), 1700)
}

const syncFromFragments = (fragments) => {
  if (!fragments || !fragments['span.site-header__cart-count']) return null
  const count = parseCountFromHtml(fragments['span.site-header__cart-count'])
  applyHeaderCount(count)
  setHasItemsState(count > 0)
  return count
}

const refreshFragments = () => {
  if (!window.jQuery || !window.wc_add_to_cart_params || !window.wc_add_to_cart_params.wc_ajax_url) return

  const $ = window.jQuery
  const endpoint = window.wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments')

  $.ajax({
    type: 'POST',
    url: endpoint,
    success: (response) => {
      const data = normalizeResponse(response)
      syncFromFragments(data && data.fragments ? data.fragments : null)
    },
  })
}

const initGlobalListeners = () => {
  if (!window.jQuery) return
  const $ = window.jQuery

  $(document.body).on('added_to_cart', (event, fragments) => {
    syncFromFragments(fragments)
    showNotice()
    setHasItemsState(true)
  })
}

const initAjaxSingleAddToCart = () => {
  if (!window.jQuery || !window.wc_add_to_cart_params || !window.wc_add_to_cart_params.wc_ajax_url) return

  const $ = window.jQuery
  const endpoint = window.wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart')

  $(document).on('submit', 'form.cart', function onSubmit(event) {
    const $form = $(this)
    const $button = $form.find('.single_add_to_cart_button')
    if (!$button.length) return
    if ($button.hasClass('disabled') || $button.hasClass('wc-variation-selection-needed')) return

    event.preventDefault()

    const formData = $form.serialize()
    const productId = $form.find('[name="add-to-cart"]').val() || $button.val()
    const payload = productId ? `${formData}&add-to-cart=${productId}` : formData

    $button.addClass('loading').prop('disabled', true)

    $.ajax({
      type: 'POST',
      url: endpoint,
      data: payload,
      success: (response) => {
        const data = normalizeResponse(response)
        if (!data) return
        if (data.error && data.product_url) {
          window.location = data.product_url
          return
        }

        syncFromFragments(data.fragments || null)
        $(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash, $button])
        $(document.body).trigger('wc_fragment_refresh')
        refreshFragments()
      },
      complete: () => {
        $button.removeClass('loading').prop('disabled', false)
      },
    })
  })
}

const initInitialState = () => {
  let hasItems = false
  const badge = document.querySelector('.site-header__cart-count')

  if (badge) {
    const raw = badge.getAttribute('data-count') || badge.textContent || '0'
    hasItems = parseInt(raw, 10) > 0
  }

  if (!hasItems) {
    try {
      hasItems = window.sessionStorage.getItem(STORAGE_KEY) === '1'
    } catch (error) {
      // Ignore.
    }
  }

  setSeeOrderVisible(hasItems)
  refreshFragments()
}

const initAjaxCart = () => {
  initGlobalListeners()
  initAjaxSingleAddToCart()
  initInitialState()
}

export default initAjaxCart



// WEBPACK FOOTER //
// ./resources/assets/js/components/ajax-cart.js